import {
  Button,
  Dialog,
  DialogBody,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  Typography,
} from "@suraasa/placebo-ui"

import WebCam from "../_assets/web_cam.webp"

interface MonitoredSessionOverlayProps {
  onProceed: () => void
  open: boolean
  onOpenChange: (open: boolean) => void
}

const StartMonitoredSessionDialog = ({
  onProceed,
  open,
  onOpenChange,
}: MonitoredSessionOverlayProps) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader hideClose>
          <DialogTitle>Monitored Session</DialogTitle>
        </DialogHeader>

        <DialogBody className="p-2">
          <div className="flex flex-col-reverse items-center gap-4 md:flex-row">
            <div className="flex-1 space-y-2">
              <Typography variant="strong" className="block text-onSurface-900">
                We will monitor your session for review
              </Typography>

              <Typography
                variant="smallBody"
                className="block text-onSurface-600"
              >
                You will be monitored via video and screen recording during this
                session to prevent unfair practices. This feed may be viewed in
                real time and/or reviewed later for monitoring and audit
                purposes.
              </Typography>
            </div>
            <img src={WebCam} alt="" width={120} className="object-contain" />
          </div>
        </DialogBody>
        <DialogFooter>
          <Button variant="filled" color="black" onClick={onProceed}>
            Proceed to Test
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}

export default StartMonitoredSessionDialog
